const getters = {
    version: state => state.version,
    backendServer: state => state.backendServer,
    error: state => state.error
}

export default getters;